import React, {useEffect} from "react";

function MentionLegale() {
  useEffect(() => {
    document.title = "Mentions légales — Temple de Sommières (ASTS)";
  }, []);

  return (
    <main id="main-content" className="mentions-legales">
      <img
        src="/images/temple.jpg"
        alt="Temple de Sommières"
        className="header-image"
      />
      <h1>Mentions Légales</h1>
      <p>
        Propriétaire du site&nbsp;: Association de Sauvegarde du Temple de
        Sommières.
      </p>
      <p>Adresse&nbsp;: 16 route de Montpellier, 30250 Sommières</p>
      <p>
        Email&nbsp;:{" "}
        <a href="mailto:astsommieres@gmail.com">astsommieres@gmail.com</a>
      </p>
      <p>Hébergement&nbsp;: Amazon Web Services, Inc.</p>
      <p>Directeur de la publication&nbsp;: Claire Daguzon, Raphaël Cousin</p>
    </main>
  );
}

export default MentionLegale;
